"use strict";
var Observable_1 = require('../../Observable');
var shareReplay_1 = require('../../operator/shareReplay');
Observable_1.Observable.prototype.shareReplay = shareReplay_1.shareReplay;
//# sourceMappingURL=shareReplay.js.map


//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/rxjs/add/operator/shareReplay.js
// module id = ../../../../rxjs/add/operator/shareReplay.js
// module chunks = 4